import DashboardPage from "./DashboardPage";

const DashboardPageConnected = () => {
  return <DashboardPage />;
};

export default DashboardPageConnected;
